import StakingEmissionsToDate from '../../../PlatformSummary/Staking/StakingEmissionsToDate';
import SpoolEmissionRewards from './SpoolEmissionRewards';
import VoSpoolEmissionRewards from './VoSpoolEmissionRewards';

const EmissionRewards = () => {
    return (
        <div className='emission-rewards'>
            <SpoolEmissionRewards />
            <VoSpoolEmissionRewards />
            <StakingEmissionsToDate />
        </div>
    );
};

export default EmissionRewards;
